import { Pagination } from "../../../model/paginatiion";
import { INewsReponse } from "../../../model/base/response/news-response";
import { INewsCategoryResponse } from "../../../model/base/response/news-category-response";

export interface NewsState {
    news: Pagination<INewsReponse>;
    categories: INewsCategoryResponse[];
    loading: boolean;
    loadingFilters: boolean;
}

export const ACTION_TYPES = {
    setNews: 'SET_NEWS' as const,
    setCategories: 'SET_CATEGORIES' as const,
    setLoading: 'SET_LOADING' as const,
    setLoadingFilters: 'SET_LOADING_FILTERS' as const,
};

type Action =
    | { type: 'SET_NEWS'; payload: Pagination<INewsReponse> }
    | { type: 'SET_CATEGORIES'; payload: INewsCategoryResponse[] }
    | { type: 'SET_LOADING'; payload: boolean }
    | { type: 'SET_LOADING_FILTERS'; payload: boolean };

export const NewsReducer = (state: NewsState, action: Action): NewsState => {
    switch (action.type) {
        case ACTION_TYPES.setNews:
            return {
                ...state,
                news: action.payload,
                loading: false,
            };
        case ACTION_TYPES.setCategories:
            return {
                ...state,
                categories: action.payload,
                loadingFilters: false,
            };
        case ACTION_TYPES.setLoading:
            return {
                ...state,
                loading: action.payload,
            };
        case ACTION_TYPES.setLoadingFilters:
            return {
                ...state,
                loadingFilters: action.payload,
            };
        default:
            return state;
    }
};
